module.exports = __webpack_public_path__ + "static/media/IMG_0813.fbb30cc8.jpeg";